import { createClient } from "contentful";

export default createClient({
  space: "zgktuhknt9f3",
  accessToken: 'cNlWFzFY2fr8vd7YTifhSjV1Yrhjo8uY755e26Il1cQ',
  
});
